// @flow
import * as React from 'react';
import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';

import Button from 'app/common/ui/Button';
import withToggle from 'app/common/containers/withToggle';

import AddChild from '../AddChild';
import withChildAddPermission from '../withChildAddPermission';


type Props = {
  handleToggle: (e: SyntheticEvent<HTMLElement>) => void,
  isOpen: boolean,
}

const enhance = compose(
  withToggle(),
  withChildAddPermission,
  branch(
    ({ enableChildAdd, hasStudents }) => (!enableChildAdd || !hasStudents),
    renderNothing
  )
);

const AddChildButton = ({ handleToggle, isOpen }: Props) => (
  <div>
    <Button
      onClick={handleToggle}
      value="Добавить ребёнка"
      outline
    />
    <AddChild isOpen={isOpen} onClose={handleToggle} />
  </div>
);

export default enhance(AddChildButton);
